import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import CKEditor from 'ckeditor4-react'
import { ckeditorToolbar } from '../helpers'
import { Row } from 'react-flexbox-grid'
import { GlgButton, GlgSwitch, GlgRangeSlider, GlgColorPicker } from 'SharedComponents'
import ChangeImagePopup from './change_image_popup'
import HeaderComponent from './header_component'
import { NONE, MIN_HEADER_HEIGHT, MAX_HEADER_HEIGHT, HEADER_VARS } from '../constants'

class HeaderSetupComponent extends Component {

  setEditorDefaultConfiguration(editor) {
    const userSetEmptyText = this.props.text === ''
    if ( (editor.getData() || '').length > 0 || userSetEmptyText ) {
      return
    }
    const usgaDefaultStyle = 
      `<p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 20px;">
          %event.name%
        </span></span>
      </p>`
    const regularDefaultStyle =
      `<p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 20px;">
          %event.name%
        </span></span>
      </p>
      <p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 20px;">
          %round.date%
        </span></span>
      </p>`
    const defaultStyle = this.props.brand === 'usga' ? usgaDefaultStyle : regularDefaultStyle
    editor.setData( defaultStyle )
    this.props.setText( defaultStyle )
  }

  render(){
    const {
      isVisible,
      toggleVisible,
      height,
      changeHeight,
      selectedBackground,
      backgroundImage,
      backgroundOpacity,
      changeOpacity,
      selectBackgroundType,
      text,
      setText,
      setBackgroundColor,
      setEditorInstance,
    } = this.props

    return (
      <div id='header_setup' className='grey_border'>
        <div className='justify-center add-margin-top-15'>
          <GlgSwitch
            id='header-popup-visible-switch'
            text={ [ (!window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.visible')),
                                                           (!window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.hidden')) ] }
            widthInPixels={ 80 }
            checked={ isVisible }
            onChange={ toggleVisible } />
        </div>
        <Row>
          <ul className='col-xs-12 col-sm-8'>
            <li className='form_row no-border-bottom'>
              <div className='col-xs-12'>
                <div className='popup-section-title'>
                  { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.preview') }
                </div>
              </div>
              <div className='col-xs-12'>
                <div className='popup-section'>
                  <HeaderComponent isPreview={true} {...this.props} />
                </div>
              </div>
            </li>
            <li className='form_row no-border-bottom'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('buttons.edit') }
              </div>
              <div className='popup-section col-xs-12'>
                <CKEditor
                  id="header_content_textarea"
                  data={ text }
                  onChange={ (e) => setText(e.editor.getData()) }
                  onInstanceReady={ e => {
                    setEditorInstance(e.editor)
                    this.setEditorDefaultConfiguration(e.editor)
                    window.glg.translation.ckeditorHtmlLang(e.editor)
                  } }
                  config={{
                    toolbar: ckeditorToolbar,
                    contentsCss: this.props.ckeditorStyle,
                    resize_maxHeight: 400,
                    height: 100,
                  }} />
              </div>
            </li>
            <li className='form_row no-border-bottom'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.fields') }
              </div>
              <div className='popup-section col-xs-12'>
                <div className='input_fields input_fields_height no-padding white_background'>
                  <div className='col-xs-12'>
                    { HEADER_VARS.map( ([ label, placeholder ], index) => (
                      <a
                        className='insert-in-ckeditor'
                        key={ index }
                        onClick={ () => { this.props.editorInstance.insertText(placeholder) } }
                      >
                        { !window.I18n ? '' : window.I18n.t('tv_shows.constants.' + label.replace(' ', '_').toLowerCase()) }
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul className='col-xs-12 col-sm-4 no-padding-left'>
            <li className='form_row add-margin-right-20'>
              <div className='col-xs-12 col-md-6'>
                <div className='popup-section-title logo-section-title'>
                  { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.left_logo') }
                </div>
                <div className='popup-section vertical-align-items'>
                  <div className='logo-container'>
                    { this.props.leftLogo === NONE ?
                      (
                        <div className='logo-none'>
                          { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.none') }
                        </div>
                      ) :
                      (
                        <img src={ this.props.leftLogo } />
                      )
                    }
                  </div>
                  <GlgButton
                    className='float-right'
                    text={ !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.change') }
                    color="white"
                    onClick={ () => { this.props.setPopupProperty('leftLogo', 'show', true) } } />
                </div>
              </div>
              <div className='col-xs-12 col-md-6'>
                <div className='popup-section-title logo-section-title'>
                  { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.right_logo') }
                </div>
                <div className='popup-section vertical-align-items'>
                  <div className='logo-container'>
                    { this.props.rightLogo === NONE ?
                      (
                        <div className='logo-none'>
                          { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.none') }
                        </div>
                      ) : (
                        <img  src={ this.props.rightLogo } />
                      )
                    }
                  </div>
                  <GlgButton
                    className='float-right'
                    text={ !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.change') }
                    color="white"
                    onClick={ () => { this.props.setPopupProperty('rightLogo', 'show', true) } } />
                </div>
              </div>
            </li>
            <li className='form_row add-margin-top-20 add-margin-right-20'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.header_height') }
              </div>
              <div className='popup-section col-xs-12 vertical-align-items'>
                <GlgRangeSlider
                  value={ height }
                  min={ MIN_HEADER_HEIGHT }
                  max={ MAX_HEADER_HEIGHT }
                  unit={ 'px' }
                  onChange={ changeHeight } />
              </div>
            </li>
            <li className='form_row add-margin-top-20 add-margin-right-20 no-border-bottom clearfix' style={{ overflow: 'visible' }}>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.background') }
              </div>
              <div className='popup-section vertical-align-items col-xs-12 no-padding'>
                <div className='col-xs-4 add-margin-top-20 add-margin-bottom-20'>
                  <div className='radio btsp_radio radio-primary no-margin'>
                    <input
                      type="radio"
                      checked={ selectedBackground === 'none' }
                      onChange={ () => { selectBackgroundType('none') } }
                      id="none" />
                    <label htmlFor="none">
                      <span>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.none').toLowerCase() }
                      </span>
                    </label>
                  </div>
                  <div className='radio btsp_radio radio-primary no-margin'>
                    <input
                      type="radio"
                      checked={ selectedBackground === 'color' }
                      onChange={ () => { selectBackgroundType('color') } }
                      id="color" />
                    <label htmlFor="color">
                      <span>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.color') }
                      </span>
                    </label>
                  </div>
                  <div className='radio btsp_radio radio-primary no-margin'>
                    <input
                      type="radio"
                      checked={ selectedBackground === 'image' }
                      onChange={ () => { selectBackgroundType('image') } }
                      id="image" />
                    <label htmlFor="image">
                      <span>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.image') }
                      </span>
                    </label>
                  </div>
                </div>
                { selectedBackground === 'color' && (
                  <div className='col-xs-8'>
                    <div className='background-container'>
                      <GlgColorPicker
                        name="background[color]"
                        color={ this.props.backgroundColor }
                        pickerPosition="top"
                        disableAlpha={ true }
                        onChange={ color => { setBackgroundColor(color.hex) } } />
                    </div>
                  </div>
                )}
                { selectedBackground === 'image' && (
                  <Fragment>
                    <div className='col-xs-4'>
                      <div className='background-container'>
                        <img src={ backgroundImage } />
                      </div>
                    </div>
                    <div className='col-xs-4'>
                      <GlgButton
                        className='float-right'
                        text={ !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.change') }
                        color="white"
                        onClick={ () => { this.props.setPopupProperty('backgroundImage', 'show', true) } } />
                    </div>
                  </Fragment>
                )}
              </div>
            </li>

            <li className='form_row add-margin-top-20 add-margin-right-20'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.header_setup_component.background_opacity') }
              </div>
              <div className='popup-section col-xs-12 vertical-align-items' style={{ height: '100%' }}>
                <GlgRangeSlider
                  value={ backgroundOpacity }
                  unit={ '%' }
                  onChange={ changeOpacity } />
              </div>
            </li>
          </ul>
        </Row>
        <ChangeImagePopup
          { ...this.props.popups.leftLogo }
          fetchImagesPath={ this.props.paths.fetchHeaderLogosLinks }
          uploadImagePath={ this.props.paths.uploadLogo }
          updateImageTitlePath= { this.props.paths.updateLogoOrBannerTitle }
          onClose={ () => { this.props.setPopupProperty('leftLogo', 'show', false) } }
          setImage={ (value) => this.props.setImage('leftLogo', value) } />
        <ChangeImagePopup
          { ...this.props.popups.rightLogo }
          fetchImagesPath={ this.props.paths.fetchHeaderLogosLinks }
          uploadImagePath={ this.props.paths.uploadLogo }
          updateImageTitlePath= { this.props.paths.updateLogoOrBannerTitle }
          onClose={ () => { this.props.setPopupProperty('rightLogo', 'show', false) } }
          setImage={ (value) => this.props.setImage('rightLogo', value) } />
        <ChangeImagePopup
          { ...this.props.popups.backgroundImage }
          fetchImagesPath={ this.props.paths.fetchBannersImagesLinks }
          uploadImagePath={ this.props.paths.uploadBanner }
          updateImageTitlePath= { this.props.paths.updateLogoOrBannerTitle }
          onClose={ () => { this.props.setPopupProperty('backgroundImage', 'show', false) } }
          setImage={ (value) => this.props.setImage('backgroundImage', value) } />
      </div>
    )
  }
}

// ================================================================================================================

HeaderSetupComponent.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  show: PropTypes.bool,
  height: PropTypes.number.isRequired,
  toggleVisible: PropTypes.func.isRequired,
  changeHeight: PropTypes.func.isRequired,
  leftLogo: PropTypes.string.isRequired,
  rightLogo: PropTypes.string.isRequired,
  selectedBackground: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  setImage: PropTypes.func.isRequired,
  backgroundOpacity: PropTypes.number.isRequired,
  changeOpacity: PropTypes.func.isRequired,
  selectBackgroundType: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  setText: PropTypes.func.isRequired,
  setBackgroundColor: PropTypes.func.isRequired,
  popups: PropTypes.object.isRequired,
  editorInstance: PropTypes.object,
  setEditorInstance: PropTypes.func.isRequired,
  setPopupProperty: PropTypes.func.isRequired,
  ckeditorStyle: PropTypes.string.isRequired,
  paths: PropTypes.object.isRequired,
  brand: PropTypes.string.isRequired,
}

export default HeaderSetupComponent
